// TODO: Change component and file name
// the name of this component is not correct it all
// it bears no resemblance to what this component actually is.
// This is not a generic popover component.
// This is a dropdown menu in the calendar page with some options related to the menu so it should be named accordingly.

import { Popover, Transition } from "@headlessui/react";
import {
  DotsVerticalIcon,
  RefreshIcon,
  ChevronLeftIcon,
  PencilAltIcon,
} from "@heroicons/react/solid";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  AnnotationIcon,
  PresentationChartBarIcon,
  ShieldCheckIcon,
  TableIcon,
  UserIcon,
} from "@heroicons/react/outline";
type PopoverComponentProps = {
  id: string | number;
  setOpen: () => void;
};
export default function KhetmaPopoverComponent(props: PopoverComponentProps) {
  const { id, setOpen } = props;
  const LocalBasePath = "page.supervisor.student";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });

  return (
    <div className=" top-16">
      <Popover className="relative">
        {({ open }) => (
          <>
            <Popover.Button className="inline-flex items-center px-2 py-2 bg-transparent rounded-none focus:outline-none">
              {" "}
              <DotsVerticalIcon className="w-6 h-6 text-gray-500 cursor-pointer " />
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-50 rounded-md  w-screen max-w-sm px-4 mt-3  rtl:sm:-left-[0%] rtl:-left-[80%] ltr:sm:right-0 ltr:-right-[75%] rtl:md:-right-36 rtl:lg:-right-full   ltr:lg:-right-[250%]   ltr:md:-right-[350%]   transform  rtl:md:translate-x-52 ltr:md:-translate-x-1/2  sm:px-0 lg:w-[296px]">
                <div className="overflow-hidden  rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                  <div className="relative   grid grid-cols-1 gap-[10px] bg-white p-6">
                    <Link
                      to={`/supervisor/dashboard/student/${id}/?tab=0`}
                      className="flex flex-row items-center justify-between w-full pb-[10px] text-sm text-gray-500 border-b border-gray-200"
                    >
                      <div className="flex flex-row gap-2">
                        <UserIcon className="w-6 h-6" />
                        <p>{t("showProfile")}</p>
                      </div>
                      <ChevronLeftIcon className="w-5 h-5 ltr:rotate-180" />
                    </Link>

                    <Link
                      to={`/supervisor/dashboard/student/${id}/?tab=1`}
                      className="flex flex-row items-center justify-between w-full pb-[10px] text-sm text-gray-500 border-b border-gray-200"
                    >
                      <div className="flex flex-row gap-2">
                        <PresentationChartBarIcon className="w-6 h-6" />
                        <p className="">{t("showSkills")}</p>
                      </div>
                      <ChevronLeftIcon className="w-5 h-5 ltr:rotate-180" />
                    </Link>

                    <Link
                      to={`/supervisor/dashboard/student/${id}?tab=2`}
                      className="flex border-b border-gray-200  flex-row items-center justify-between w-full pb-[10px] text-sm text-gray-500"
                    >
                      <div className="flex flex-row gap-2">
                        <AnnotationIcon className="w-6 h-6" />
                        <p>{t("showNotes")}</p>
                      </div>
                      <ChevronLeftIcon className="w-5 h-5 ltr:rotate-180" />
                    </Link>
                    <a
                      onClick={setOpen}
                      className="flex cursor-pointer  flex-row items-center justify-between w-full pb-[10px] text-sm text-gray-500"
                    >
                      <div className="flex flex-row gap-2">
                        <ShieldCheckIcon className="w-6 h-6" />
                        <p>{t("recommendation")}</p>
                      </div>
                      <ChevronLeftIcon className="w-5 h-5 ltr:rotate-180" />
                    </a>
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  );
}
